/* OVESSI_HAIRCARE_PILOT_JS v3 — loaded via CDN asset, bypasses Shopify page_cache.
   Runs only on the Hair Care collection (theme.liquid loads us conditionally).
   Responsibilities:
     1. Add data-haircare-pilot to the product grid wrapper (in case body class missed it)
     2. Insert .ovessi-outcome-line below the title with the product's outcome metafield/excerpt
     3. Wrap .price + .quick-add into .ovessi-price-cta-row
     4. Rename "Add to Cart" -> "Add to Ritual"
     5. Re-run after AJAX/section re-renders via MutationObserver
*/
(function () {
  // OVESSI_HAIRCARE_KILL_SWITCH_OVERRIDE — inject a high-specificity CSS rule
  // that defeats any stale base.css with the OLD OVESSI_HAIRCARE_PILOT_HIDE_HERO_DESC
  // kill rule. Runs synchronously at script load, before paint.
  (function injectOverrideCSS() {
    if (document.getElementById('ovessi-haircare-killswitch-override')) return;
    var style = document.createElement('style');
    style.id = 'ovessi-haircare-killswitch-override';
    style.textContent = [
      'html body[data-collection-handle="haircare"] .luv-coll-hero .luv-coll-hero__desc,',
      'html body[data-collection-handle="haircare"] .luv-coll-hero__desc {',
      '  display: block !important;',
      '  visibility: visible !important;',
      '  height: auto !important;',
      '  overflow: visible !important;',
      '  margin: 14px auto 0 !important;',
      '  padding: 0 !important;',
      '  max-width: 54ch;',
      '}',
      'html body[data-haircare-pilot] #product-grid .card-wrapper .card .card__content,',
      'html body[data-haircare-pilot] #product-grid .card-wrapper .card .card-information {',
      '  padding: 20px 4px 16px !important;',
      '}',
      '@media (min-width: 990px) {',
      '  html body[data-haircare-pilot] #product-grid .card-wrapper .card .card__content,',
      '  html body[data-haircare-pilot] #product-grid .card-wrapper .card .card-information {',
      '    padding: 24px 4px 20px !important;',
      '  }',
      '}'
    ].join('\n');
    (document.head || document.documentElement).appendChild(style);
  })();

  'use strict';

  var INIT_FLAG = '__ovessiHaircarePilotV3';
  if (window[INIT_FLAG]) return;
  window[INIT_FLAG] = true;

  console.log('[OVESSI haircare pilot v3] booting');

  function isHaircarePage() {
    var p = (window.location.pathname || '').toLowerCase();
    return p.indexOf('/collections/haircare') === 0 || p.indexOf('/collections/haircare/') === 0;
  }

  if (!isHaircarePage()) {
    console.log('[OVESSI haircare pilot v3] not on /collections/haircare, exit');
    return;
  }

  // ---------- helpers ----------
  function findGrid() {
    return document.querySelector('#product-grid, ul.product-grid');
  }

  function findOuterCardContent(card) {
    // The OUTER .card__content is the sibling of .card__inner (the one BELOW the image).
    // The inner one (overlay style) sits INSIDE .card__inner.
    var inner = card.querySelector(':scope > .card__inner, :scope > .card > .card__inner, .card > .card__inner');
    var allContents = card.querySelectorAll('.card__content');
    for (var i = 0; i < allContents.length; i++) {
      if (!inner || !inner.contains(allContents[i])) return allContents[i];
    }
    return allContents[allContents.length - 1] || null;
  }

  function getOutcomeText(card) {
    // Try a few signals — outcome metafield from data attr, then a sibling caption
    var src = card.querySelector('[data-product-outcome], [data-outcome], .product-outcome');
    if (src && src.textContent.trim()) return src.textContent.trim();
    // Fallback: short caption beneath title in source markup
    var caption = card.querySelector('.card-information .caption-with-letter-spacing, .card__information .caption-with-letter-spacing');
    if (caption && caption.textContent.trim()) return caption.textContent.trim();
    return null;
  }

  function rewriteCard(card) {
    if (card.dataset.ovessiV3 === '1') return;

    // 1. Tag wrapper so [data-haircare-pilot] scoped CSS applies
    var grid = card.closest('#product-grid');
    if (grid && !grid.parentElement.hasAttribute('data-haircare-pilot')) {
      grid.parentElement.setAttribute('data-haircare-pilot', '');
    }

    var outer = findOuterCardContent(card);
    if (!outer) {
      card.dataset.ovessiV3 = '1';
      return;
    }

    var info = outer.querySelector('.card__information, .card-information') || outer;
    var heading = info.querySelector('.card__heading');

    // 2. Insert outcome line right after heading if not present and we have text
    if (heading && !info.querySelector('.ovessi-outcome-line')) {
      var text = getOutcomeText(card);
      if (text) {
        var line = document.createElement('p');
        line.className = 'ovessi-outcome-line';
        line.textContent = text;
        heading.insertAdjacentElement('afterend', line);
      }
    }

    // 3. Build price+CTA row
    var price = outer.querySelector('.price');
    var cta = outer.querySelector('.quick-add');

    if (price && cta && !outer.querySelector('.ovessi-price-cta-row')) {
      var row = document.createElement('div');
      row.className = 'ovessi-price-cta-row';
      // Insert row where price currently sits
      price.parentNode.insertBefore(row, price);
      row.appendChild(price);
      row.appendChild(cta);
    }

    // 4. Rename "Add to Cart" -> "Add to Ritual"
    if (cta) {
      var btn = cta.querySelector('.quick-add__submit, button[type="submit"], button');
      if (btn) {
        var replaced = false;
        // Walk text nodes
        var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT, null);
        var node;
        while ((node = walker.nextNode())) {
          var t = node.nodeValue;
          if (/add to cart/i.test(t)) {
            node.nodeValue = t.replace(/add to cart/ig, 'Add to Ritual');
            replaced = true;
          }
        }
        // If nothing matched, scan spans
        if (!replaced) {
          var spans = btn.querySelectorAll('span');
          for (var s = 0; s < spans.length; s++) {
            if (spans[s].classList.contains('svg-wrapper')) continue;
            if (spans[s].classList.contains('loading__spinner')) continue;
            if (/cart/i.test(spans[s].textContent)) {
              spans[s].textContent = 'Add to Ritual';
              replaced = true;
              break;
            }
          }
        }
        btn.setAttribute('aria-label', 'Add to Ritual');
        btn.setAttribute('data-ovessi-relabelled', '1');
      }
    }

    card.dataset.ovessiV3 = '1';
  }

  function rewriteAll() {
    var grid = findGrid();
    if (!grid) return;
    var cards = grid.querySelectorAll('.card-wrapper, .grid__item');
    cards.forEach(rewriteCard);
  }

  // Throttled MutationObserver — re-run after Shopify AJAX/filter renders
  var pending = false;
  function scheduleRewrite() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      rewriteAll();
    });
  }

  function boot() {
    rewriteAll();
    var grid = findGrid();
    if (grid && 'MutationObserver' in window) {
      var mo = new MutationObserver(scheduleRewrite);
      mo.observe(grid, { childList: true, subtree: true });
    }
    // Re-run a few times to catch late hydrations
    setTimeout(rewriteAll, 500);
    setTimeout(rewriteAll, 1500);
    setTimeout(rewriteAll, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  console.log('[OVESSI haircare pilot v3] ready');
})();
